import FastPay from './fast-pay'

export default FastPay
